export * from './core'
export * from './methods'

// 导出一个默认的配置好的 bridge 实例
import { bridge, isInApp } from './core'
import { nativeMethod } from './methods'

export default {
  bridge,
  isInApp,
  ...nativeMethod
} 